// extracted by mini-css-extract-plugin
export var addToCartWrapper = "_wi-8";
export var editMode = "_wi-3";
export var headerRow = "_wi-a";
export var headerTitle = "_wi-b";
export var product = "_wi-1";
export var productDetails = "_wi-5";
export var productDivider = "_wi-7";
export var productImage = "_wi-2";
export var productInfo = "_wi-4";
export var productTitle = "_wi-6";
export var strikethrough = "_wi-9";
export var upsellProductsCard = "_wi-0";